export const getStreetName = (addressLine1?: string): string | null => {
  if (!addressLine1) return null;
  const parts = addressLine1.split(" ");

  if (parts.length > 1 && !Number.isNaN(Number(parts[0]))) {
    return parts.slice(1).join(" ");
  }
  if (parts.length === 1 && !Number.isNaN(Number(parts[0]))) {
    return null;
  }
  return parts.join(" ");
};
